import { Card } from 'antd';
import { motion } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';

const LockedDoctor = () => {
    const { t } = useLanguage();

    return (
        <div className="bg-gradient-to-br from-gray-50 via-blue-50 to-gray-100 min-h-screen flex justify-center px-4">
            <div className="w-full max-w-2xl mx-auto">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                >
                    <Card className="bg-white/90 backdrop-blur-sm shadow-2xl border-0 rounded-3xl overflow-hidden">
                        <div className="relative p-8 md:p-12 text-center">
                            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-amber-400 via-orange-500 to-red-500"></div>
                            
                            <div className="mb-6">
                                <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-amber-100 rounded-full mb-4">
                                    <span className="text-3xl md:text-4xl">⚠️</span>
                                </div>
                            </div>

                            <h2 className="text-xl md:text-3xl font-bold text-gray-800 mb-4">
                                {t('locked.title')}
                            </h2>

                            {/* Main message */}
                            <p className="text-sm md:text-lg text-gray-600 mb-4 leading-relaxed">
                                {t('locked.message')}
                            </p>

                            {/* Positive message */}
                            <div className="bg-green-50 border border-green-200 rounded-2xl p-4 md:p-6 mb-6">
                                <div className="flex items-center justify-center mb-2">
                                    <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3">
                                        <span className="text-green-600 text-lg">✓</span>
                                    </div>
                                </div>
                                <p className="text-sm md:text-base text-green-700">
                                    {t('locked.existingAppointments')}
                                </p>
                            </div>
                        </div>
                    </Card>
                </motion.div>
            </div>
        </div>
    );
}

export default LockedDoctor;